module.exports = __webpack_public_path__ + "static/media/selcareBT.6481556b.png";